<template>
  <div>
    <el-dialog title="Select Tier" :visible="dialog_select_tier" width="30%" top="3vh" @open="open()" @close="close()">
      <el-select v-model="user_tier" clearable filterable class="mr10 capitalize">
        <el-option v-for="t in tiers" :key="t.value" :value="t.value" :label="t.name"></el-option>
      </el-select>
      <div slot="footer">
        <el-button type="primary" size="mini" @click="updateTierVC()">
          Save
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  data() {
    return {
      user_tier: 0
    }
  },
  computed:{
    ...mapState('user', [
      'dialog_select_tier',
      'user'
    ]),
  },
  methods: {
    ...mapMutations('user', [
      'setTierDialog'
    ]),
    ...mapActions('artistUsers', ['readArtistUsers']),
    ...mapActions('creatorUsers', ['readCreatorUsers']),
    ...mapActions('labelUsers', ['readLabelUsers']),
    ...mapActions('mcnUsers', ['readMcnUsers']),
    ...mapActions('permissionUsers', ['readPermissionUsers']),
    ...mapActions('user', ['updateVcApplicationStatus']),
    updateTierVC() {
      let channel = {}
      this.user.channels.filter(a => {
        if(a.platform == 'youtube') channel = a
      })
      this.user.user_tier = this.user_tier
      this.updateVcApp(
          channel,
          this.user_tier
      ).then(() => {
        this.readArtistUsers()
        this.readCreatorUsers()
        this.readLabelUsers()
        this.readMcnUsers()
        this.readPermissionUsers()
        this.resetForm()
        this.setTierDialog(false)
      })
    },
    async updateVcApp(c,tier) {
      if (c.platform === 'youtube') {
        await this.updateVcApplicationStatus({
          channel_id: c.channel_id,
          status: 1,
          tier
        })
      }
    },
    open(){
      this.user_tier = this.user.user_tier
    },
    close(){
      this.resetForm()
      this.setTierDialog(false)
    },
    resetForm(){
      this.user_tier = 0
      this.user_channel = {}
    }
  }
}
</script>